<template>
  <div class="debt-waitlist">
      <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-money"></i> Debt Wait</span>
            <el-button
              style="float: right"
              icon="el-icon-download"
              size="small"
              type="success"
              @click="Report()"
              >Export</el-button>
          </div>
          <data-tables 
              :data="dataTable" 
              border 
              :page-size="20"
              :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
              <el-table-column prop="addDate" label="Add Date" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="paidDate" label="Paid Date" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="member_code" label="Member Code" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="description" label="Description" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="status" label="Status" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="amountFormat" label="Amount" header-align="center" align="center"> </el-table-column>
              <el-table-column prop="uid" label="Action" header-align="center" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="payDebt(scope.row)">Pay</el-button>
                  <el-button size="mini" type="primary" @click="showDetail(scope.row)">View</el-button>
                </template>
              </el-table-column>
   
            </data-tables>
      </el-card>

      <el-dialog
          title="Debt Detail"
          :visible.sync="dialogVisible"
          :width="device === 'mobile' ? '95%' : '70%'"
          top="5vh">
          <el-row :gutter="10" v-if="debtDetail">
            <el-col :xs="24" :sm="24" :md="24" :lg="12">
              <el-form
                    label-width="100px"
                    size="small"
                    :label-position="device === 'mobile' ? 'left' : 'right'"
                  >
                  <el-form-item label="Add Date">
                    {{ debtDetail.addDate }}
                  </el-form-item>
                  <el-form-item label="Amount">
                    {{ debtDetail.amountFormat }}
                  </el-form-item>
                  <el-form-item label="Description">
                    {{ debtDetail.description }}
                  </el-form-item>
                  <el-form-item label="Paid Date">
                    {{ debtDetail.paidDate }}
                  </el-form-item>
                  <el-form-item label="Status">
                    {{ debtDetail.status }}
                  </el-form-item>



              </el-form>

            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="12">

              <h4>Transaction Detail</h4>
              <pre v-html="detailRender(debtDetail.meta)"></pre>

            </el-col>

          </el-row>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Close</el-button>
        </span>
      </el-dialog>

      <el-dialog
          title="Debt Pay"
          :visible.sync="dialogDebtPay"
          :width="device === 'mobile' ? '95%' : '30%'"
          top="5vh">

              <el-form
                    label-width="100px"
                    size="small"
                    :label-position="device === 'mobile' ? 'left' : 'right'"
                    v-if="debtPayDetail"
                  >
                  <el-form-item label="Add Date">
                    {{ debtPayDetail.addDate }}
                  </el-form-item>
                  <el-form-item label="Amount">
                    {{ debtPayDetail.amountFormat }}
                  </el-form-item>
                  <el-form-item label="Description">
                    {{ debtPayDetail.description }}
                  </el-form-item>
                  <el-form-item label="Paid Date">
                    {{ debtPayDetail.paidDate }}
                  </el-form-item>
                  <el-form-item label="Status">
                    {{ debtPayDetail.status }}
                  </el-form-item>



              </el-form>

           

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogDebtPay = false; debtPayDetail= null;">Close</el-button>
          <el-button type="primary" @click="submitDebtPay" :loading="submittingDebtPay">Confirm</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { getDebtLedgerList, getDebtLedgerExport, payDebt } from '@/api/debt'
export default {
  computed:{
    device() {
      return this.$store.state.app.device;
    }
  },
  props:{
    ledgerID: String
  },
  data(){
    return {
      dialogVisible: false,
      dialogDebtPay: false,
      submittingDebtPay: false,
      ledger_id: '',
      dataTable: [],
      debtDetail: null,
      debtPayDetail: null
    }
  },
  methods:{
    getLedgerList(){
      getDebtLedgerList(this.ledger_id).then(({result, data})=>{
        if(result){
          this.dataTable = data
        }
      })
    },
    showDetail(meta){
      this.debtDetail = meta
      this.dialogVisible = true
    },
    detailRender(data){
      if(!data) return "";
      let detail = []
      Object.keys(data).forEach(key => {
        
        let element = data[key]
        if(typeof element === 'object'){
          let subdetail = []

          Object.keys(element).forEach(keysub => {
            let elementsub = element[keysub]
            subdetail.push(`<b>${key}_${keysub}</b>: <code>${elementsub}</code>`)
          })

          detail.push(`${subdetail.join('\n')}`)
        
        }else{
          detail.push(`<b>${key}</b>: <code>${element}</code>`)
        }
      });

      return detail.join('\n');
    },
    Report(){
      getDebtLedgerExport(this.ledger_id)
    },
    payDebt(data){
      this.debtPayDetail = data;
      this.dialogDebtPay = true;
      this.submittingDebtPay = false;
    },
    submitDebtPay(){
      if(!this.debtPayDetail){
        this.$alert('Have something wrong. Please try again', 'Error', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
        return false;
      }

      this.submittingDebtPay = true;
      console.log(this.debtPayDetail)
      payDebt(this.debtPayDetail.uid, this.debtPayDetail.bankholderId).then(({result, message})=>{
        this.submittingDebtPay = false;
        if(result){
          this.$alert(message, 'Success', {
          confirmButtonText: 'OK',
          callback: action => {
            this.debtPayDetail = null;
            this.dialogDebtPay = true;
            setTimeout(()=>{
              window.location.reload();
            }, 500);
            
          }
        });
          
        }else{
          this.$notify({
            title: "Error",
            message: message,
            type: "error",
            duration: 2000
          });
        }
      })
    }
  },
  created(){
    this.ledger_id = this.ledgerID
    this.getLedgerList()
  }
}
</script>

<style lang="scss">
.debt-waitlist{
  code {
    color: #408fff;
    background-color: #e6effb;
    margin: 0 4px;
    display: inline-block;
    padding: 1px 5px;
    font-size: 14px;
    border-radius: 3px;
    height: 18px;
    line-height: 18px;
  }

  pre{
    white-space: pre-line;
    line-height: 30px;
  }
}
</style>